import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import * as L from 'leaflet';
import { ApiService } from '@app/core/api-service/api.service';

@Injectable({
  providedIn: 'root'
})
export class MapService {
  editDrawMap$: Subject<any> = new Subject();
  navNext$: Subject<any> = new Subject();
  editRowMap$: Subject<any> = new Subject();
  removeChildLayer$: Subject<any> = new Subject();
  showHideMap$: Subject<any> = new Subject();
  disableStep$: Subject<any> = new Subject();
  parentMapColor: string;
  childMapColor: string;
  defaultPoints: any;
  currentZoom: number;
  currentPointsUrl: string = 'districts';
  createdPoints: any[];
  layers: any[];
  removeLayer: boolean;
  selectedLayer: any;
  previousLayers: any;
  editMode: boolean;
  ids: any[] = [];
  latLngRows: any[];
  editedLayerParent: any;
  constructor(private api: ApiService) {}
  setIcon(color: string) {
    let Icon = new L.Icon({
      iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${color}.png`,
      shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
      iconSize: [25, 41],
      iconAnchor: [12, 41],
      popupAnchor: [1, -34],
      shadowSize: [41, 41]
    });
    return Icon;
  }
  getLayerByLatLng(layers: any[], latLng: any) {
    console.log('layers', layers);
    console.log('latLng', latLng);
    return layers.filter((d: any) => d['_latlng']['lat'] === latLng['lat'] && d['_latlng']['lng'] === latLng['lng'])[0];
  }

  getIndexOfLayerLatLng(layers: any[], latLng: any) {
    return layers.indexOf((d: any) => d['_latlng']['lat'] === latLng['lat'] && d['_latlng']['lng'] === latLng['lng']);
  }

  getCurrentPoints() {
    console.log('getCurrentPoints work');

    return this.api.getReq(this.currentPointsUrl + '?all_pages=1');
  }
}
